import React, { memo, useCallback } from 'react';
import { noop } from 'lodash';
import classNames from 'classnames';
import { Checkbox, Tooltip } from 'antd';
import styles from './index.less';
// eslint-disable-next-line react/display-name
const FilterPill = memo(({
  checked,
  className,
  filter,
  onChange,
  isCheckbox,
  disabled,
}) => {
  const { name, fid, rule_text: ruleText = '' } = filter;
  const truncatedRuleText = ruleText.length > 250 ? `${ruleText.substr(0, 250)}...` : ruleText;
  const classes = classNames(styles.filterPill, className);

  const onFilterChange = useCallback(() => {
    onChange(filter);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <div className={classes}>
      <Checkbox
        className={classNames({ 'checkbox-rounded': !isCheckbox })}
        checked={checked}
        onChange={onFilterChange}
        disabled={disabled}
      >
        <Tooltip
        key={fid || name}
        placement="right"
        mouseLeaveDelay={0}
        title={<span>{truncatedRuleText}</span>}
      >
        <span>
          {name}
        </span>
      </Tooltip>
    </Checkbox>
    </div>
  );
});

FilterPill.defaultProps = {
  className: '',
  checked: false,
  onChange: noop,
  isCheckbox: false,
  disabled: false,
};

export default FilterPill;
